import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const LogoutDialog = (props) => {
  const { logoutDialogOpen, setLogoutDialogOpen, logout } = props;

  const handleClose = () => {
    setLogoutDialogOpen(false);
  }

  return (
    <div>
      <Dialog
        open={logoutDialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Útskráning"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Ertu viss um að þú viljir skrá þig út úr kerfinu?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Nei
          </Button>
          <Button onClick={logout}  color="primary" autoFocus>
            Já
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default LogoutDialog;
